import React from 'react'
import { FormControl, Select, MenuItem } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import theme from '../utils/theme'

const LengthSelector = ({ selectedLength, onLengthChange, disabled = false }) => {
  const lengths = [
    { value: 'short', label: 'Corto' },
    { value: 'medium', label: 'Medio' },
    { value: 'long', label: 'Lungo' },
  ]

  return (
    <FormControl
      variant="standard"
      sx={{
        minWidth: '100px', // ensure a consistent width
        height: '44px',
        display: 'grid',
        position: 'relative',
        placeItems: 'center',
        marginLeft: 'auto',
        borderRadius: 2,
        '& .MuiInputBase-root': {
          color: 'neutral.600',
          paddingX: 1,
        },
        '& .MuiSelect-icon': {
          color: 'neutral.600',
        },
        '& .MuiInput-underline:before, & .MuiInput-underline:after': {
          borderBottom: 'none',
        },
      }}
      disabled={disabled}
    >
      <Select
        value={selectedLength}
        onChange={e => onLengthChange(e.target.value)}
        disableUnderline
        IconComponent={KeyboardArrowDownIcon}
        MenuProps={{
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
          },
          transformOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
          },
          PaperProps: {
            sx: {
              position: 'absolute',
              width: '100px',
            },
          },
        }}
      >
        {lengths.map(length => (
          <MenuItem
            sx={{ color: theme.palette.neutral[600] }}
            key={length.value}
            value={length.value}
          >
            {length.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default LengthSelector
